<template>
  <div class="atalho-simple-btn">
    <button
      class="action-btn atalho-btn d-inline-flex align-items-center"
      :class="[colorClass, { 'disabled': disabled }]"
      @click="handleButtonClick"
      :aria-label="label"
      :title="disabled ? 'Cliente inativo - Landing Page indisponível' : label"
      :tabindex="disabled ? -1 : 0"
      @keydown.enter.prevent="handleButtonClick"
      ref="btnRef"
      :disabled="disabled"
    >
      <i :class="icon" class="mr-2"></i>
      {{ label }}
      <span 
        v-if="categoria === 'lp' && !disabled"
        class="qrcode-icon-btn" 
        @click.stop="mostrarQRCode"
        :title="'Gerar QR Code para ' + label"
      >
        <i class="fas fa-qrcode"></i>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AtalhoSimpleBtn',
  props: {
    label: { type: String, required: true },
    icon: { type: String, default: 'fas fa-link' },
    color: { type: String, default: 'primary' },
    clienteId: { type: String, default: '' },
    categoria: { type: String, default: '' }, // dashboard, pwa, lp, configuracoes
    disabled: { type: Boolean, default: false },
  },
  computed: {
    colorClass() {
      return `bg-${this.color} text-white`;
    },
  },
  methods: {
    handleButtonClick(e) {
      // Verificar se o botão está desabilitado
      if (this.disabled) {
        return;
      }
      
      // Se clicou no ícone de QR Code, não fazer nada (o handler do QR Code cuida disso)
      if (e.target.closest('.qrcode-icon-btn')) {
        return;
      }
      
      // Emitir evento para abrir link
      if (this.clienteId) {
        this.$emit('abrir-link', { clienteId: this.clienteId, categoria: this.categoria, tipo: 'prod' });
      }
    },
    mostrarQRCode() {
      if (this.disabled) {
        return;
      }
      this.$emit('mostrar-qrcode', { clienteId: this.clienteId, categoria: this.categoria, tipo: 'prod' });
    },
  },
};
</script>

<style scoped>
.atalho-simple-btn {
  position: relative;
  display: inline-block;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
}

.atalho-btn {
  min-width: 180px;
  font-size: 1.08em;
  padding: 0.7em 1.3em;
  border-radius: 0.8rem;
  font-weight: 500;
  outline: none;
  border: none;
  box-shadow: var(--shadow-qs-xs);
  transition: all 0.2s;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  pointer-events: auto;
}

.atalho-btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-qs-sm);
}

.atalho-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: var(--lp-switch-track-off) !important;
  color: var(--bootstrap-adb5bd) !important;
  pointer-events: none;
}

.atalho-btn.disabled:hover {
  background: var(--lp-switch-track-off) !important;
  transform: none !important;
}

.qrcode-icon-btn {
  background: transparent;
  border: none;
  color: var(--lp-text-on-dark);
  font-size: 0.9em;
  cursor: pointer;
  padding: 0.3em 0.5em;
  margin-left: 0.5em;
  border-radius: 4px;
  transition: background 0.2s, color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-icon-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  color: var(--lp-text-on-dark);
}

@media (max-width: 600px) {
  .atalho-btn {
    min-width: 120px;
    font-size: 0.98em;
    padding: 0.5em 0.7em;
  }
}
</style> 